document.addEventListener('DOMContentLoaded', function () {
  const stickyATC = document.querySelector('.sticky_atc_container');

  function toggleSticky() {
    if (window.scrollY > 100) {
      stickyATC.classList.add('show-on-scroll');
    } else {
      stickyATC.classList.remove('show-on-scroll');
    }
  }
  toggleSticky();
  window.addEventListener('scroll', toggleSticky);
});


